var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconLoginSocialKakao = function SvgIconLoginSocialKakao(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    fill: "none",
    className: "icon_login_social_kakao_svg__css-1h47l4s"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 2.629c-4.337 0-7.857 2.734-7.857 6.097 0 2.098 1.36 3.929 3.433 5.044l-.872 3.198a.322.322 0 0 0 .495.346l3.819-2.538c.322 0 .652.055.982.055 4.337 0 7.857-2.734 7.857-6.105 0-3.37-3.52-6.097-7.857-6.097Z",
    fill: "#181600"
  })));
};
export default SvgIconLoginSocialKakao;